import { render } from "./LocationList.vue?vue&type=template&id=7dd8e99d&scoped=true"
import script from "./LocationList.vue?vue&type=script&lang=js"
export * from "./LocationList.vue?vue&type=script&lang=js"

import "./LocationList.vue?vue&type=style&index=0&id=7dd8e99d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dd8e99d"]])

export default __exports__